import { HOME_CANDIDATE_COMPONENTS_TYPES } from "@core/constants";
import { WelcomeBannerPropertiesModel } from "./welcome-banner-properties.model";
import { InfoCardsPropertiesModel } from "./info-cards-proporties.model";
import { OffersSliderPropertiesModel } from "./offer-slider-properties.model";
import { ActionCardsPropertiesModel } from "./action-cards-properties.model";

export const IHomeType = Object.freeze({
  type: "type",
  properties: "properties",
  shouldDisplayTitle: "shouldDisplayTitle",
});

export class HomeTypeModel {
  constructor(data = {}) {
    this[IHomeType.type] = data[IHomeType.type];
    this[IHomeType.properties] = data[IHomeType.properties];
    this[IHomeType.shouldDisplayTitle] = data[IHomeType.shouldDisplayTitle];
  }

  getType() {
    return this[IHomeType.type];
  }

  isWelcomeBannerType() {
    return this.getType() === HOME_CANDIDATE_COMPONENTS_TYPES.WELCOME_BANNER;
  }

  isInfoCardType() {
    return this.getType() === HOME_CANDIDATE_COMPONENTS_TYPES.INFO_CARD;
  }

  isSlideOffersType() {
    return this.getType() === HOME_CANDIDATE_COMPONENTS_TYPES.OFFERS_SLIDER;
  }

  isActionCardType() {
    return this.getType() === HOME_CANDIDATE_COMPONENTS_TYPES.ACTION_CARD;
  }

  getProperties() {
    if (this.isWelcomeBannerType()) {
      return new WelcomeBannerPropertiesModel(this[IHomeType.properties]);
    }
    if (this.isInfoCardType()) {
      return new InfoCardsPropertiesModel(this[IHomeType.properties]);
    }

    if (this.isSlideOffersType()) {
      return new OffersSliderPropertiesModel(this[IHomeType.properties]);
    }
    if (this.isActionCardType()) {
      return new ActionCardsPropertiesModel(this[IHomeType.properties]);
    }
  }
}
